import constants from './_consts';

export default {
  items: [
    {
      name: 'TOTAL DRAFTS',
      description: 'Drafts that need to be submitted or deleted.',
      url: '/user/drafts',
      color: '#BBB4AB',
      eventStatus: constants.eventStatus.drafts
    },
    {
      name: 'TOTAL SUBMITTED TO ADURO',
      url: '/user/submitted',
      description: 'Events waiting for approval from ADURO.',
      color: '#4A90E2',
      eventStatus: constants.eventStatus.submitted
    },
    {
      name: 'TOTAL EVENTS TO REVIEW',
      url: '/user/review',
      description: 'Drafts that need to be reviewed by you.',
      color: '#A42022',
      eventStatus: constants.eventStatus.review
    },
    {
      name: 'TOTAL APPROVED EVENTS',
      url: '/user/approved',
      description: 'Events that have been approved and scheduled.',
      color: '#417505',
      eventStatus: constants.eventStatus.approved
    },
    {
      name: 'TOTAL ARCHIVED EVENTS',
      url: '/user/archived',
      description: 'Events that have been approved and scheduled.',
      color: '#463E38',
      eventStatus: constants.eventStatus.archived
    }
  ]
};



// WEBPACK FOOTER //
// ./src/_dash.js